/**
 * Rahmen fuer die Unterseiten eines festen Bereichs (BE-03, BE-04): Training
 * und Ernaehrung stehen als Tabs im Bereich "Gesundheit & Körper", Stundenplan,
 * Faecher, Noten usw. im Bereich "Schule". Ihre Adressen bleiben; hier kommt
 * nur der Kopf des Bereichs darueber. Fehlt der Bereich (z. B. archiviert und
 * geloescht), erscheinen die Seiten wie bisher ohne Kopf.
 */
import { Navigate, Outlet } from 'react-router-dom';

import { BereichsKopf } from '@/modules/areas/BereichsKopf';
import { pfad } from '@/app/fokus';
import type { FesterBereich } from '@/domain/types';
import { useFesterBereich } from '@/modules/areas/useFesterBereich';

export function BereichRahmen({ fest }: { fest: FesterBereich }) {
  const area = useFesterBereich(fest);
  return (
    <>
      {area && (
        <div className="mx-auto w-full max-w-[100rem] px-4 pt-6 sm:px-6 lg:px-8">
          <BereichsKopf area={area} />
        </div>
      )}
      <Outlet />
    </>
  );
}

/** Alte Adresse `/schule`: fuehrt auf den Ueberblick des Bereichs (sonst auf die Faecher). */
export function ZumBereich({ fest, sonst }: { fest: FesterBereich; sonst: string }) {
  const area = useFesterBereich(fest);
  if (area === undefined) return null;
  return <Navigate to={area ? pfad.bereich(area.id) : sonst} replace />;
}
